import { useHead } from "@unhead/react"

const MARK_IMAGE = "https://static.lumi.new/82/822af0d68e9ac502e77f750baea02b85.webp"

function LoadingLanding() {
  useHead({
    title: "Penguin Pad Coming Soon",
    meta: [
      {
        name: "description",
        content: "Penguin Pad is warming up. Bonding-curve presale launchpad on Robinhood Chain.",
      },
    ],
  })

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-black text-white">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_42%,rgba(200,245,66,0.12)_0%,transparent_42%)]" />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_72%_28%,rgba(255,92,20,0.16)_0%,transparent_28%)]" />

      <main className="relative z-10 flex w-full max-w-md flex-col items-center px-6">
        <img
          src={MARK_IMAGE}
          alt="Penguin Pad"
          className="h-44 w-44 object-contain sm:h-56 sm:w-56"
        />

        <div
          className="mt-10 w-full max-w-[260px]"
          role="progressbar"
          aria-label="Penguin Pad loading"
          aria-valuemin={0}
          aria-valuemax={100}
        >
          <div className="h-[6px] overflow-hidden rounded-full bg-white/10">
            <div className="loading-bar-fill h-full w-1/3 rounded-full" />
          </div>
        </div>

        <p className="mt-5 text-[11px] font-semibold uppercase tracking-[0.32em] text-[#C8F542]">
          Loading
        </p>
      </main>
    </div>
  )
}

export default LoadingLanding
